import Statistics from "./components/statistics/Statistics";
import AdminLeaveRequestDataTable from "@/components/leave-request/admin-table/AdminLeaveRequestDataTable";

function AdminDashboardPage() {

  return (
    <div className="flex flex-col w-full h-screen p-4 gap-4">
      {/* Statistics section with fixed height */}
      <Statistics />

      {/* Table section that stretches to fill remaining space */}
      <div className="flex-grow flex overflow-auto">
        <AdminLeaveRequestDataTable />
      </div>
    </div>
  );
}

export default AdminDashboardPage;
